import { Component,Input,OnChanges,OnDestroy,OnInit,SimpleChanges,ViewChild } from '@angular/core';
import { FormControl,UntypedFormControl } from '@angular/forms';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { BehaviorSubject, Subject } from 'rxjs';
import { getErrorMessage } from '../../../../../helper/validation.helper';
import { takeUntil } from 'rxjs/operators';

export type MaterialColor = 'primary' | 'accent' | 'warn';

@Component({
    selector: 'app-textfield',
    templateUrl: './textfield.component.html',
    styleUrls: ['./textfield.component.scss'],
})
export class TextfieldComponent implements OnChanges, OnInit, OnDestroy {
    @ViewChild('textField') textField: HTMLElement;
    @Input() Key = '';
    @Input() Hint: string = null;
    @Input() Value: UntypedFormControl | FormControl; // | AbstractControlTyped<string>;
    @Input() Icon: IconProp = null;
    @Input() Required = false;
    @Input() CustomError = '';
    @Input() Color: MaterialColor = 'primary';
    @Input() Type:
        'color'
        | 'date'
        | 'datetime-local'
        | 'email'
        | 'month'
        | 'number'
        | 'password'
        | 'search'
        | 'tel'
        | 'text'
        | 'time'
        | 'url'
        | 'week'
        = 'text';
    public ErrorMessage$ = new BehaviorSubject<string>('');

    private destroy$ = new Subject<void>();

    ngOnInit() {
        if (this.Value) {
            this.Value.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => this.ErrorMessage$.next(this.CustomError || getErrorMessage(this.Value)));
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.ErrorMessage$.complete();
    }

    focusInput() {
        if (this.textField) {
            this.textField.focus();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.ErrorMessage$.next(this.CustomError || getErrorMessage(this.Value));
    }
}
